var path = '/assets/js/dashboard/marketplace/marketplace.html';
var html = "<style>iframe{width: 1px;min-width: 100%; height: 300rem;}</style>\n<iframe id=\"Marktplace\" ng-src=\"{{ vm.trustSrc(vm.frameUrl) }}\" frameborder=\"0\"></iframe>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;